<div class="ft-dropdown goal-incentives" [class.active]="active()" (click)="toggle($event)">
    <a class="ft-dropdown-toggle goal-name">
        <i class="icon icon-trophy"></i>
        <span [innerHTML]="goalName()"></span> <i class="ft-icn-caret-down"></i>
    </a>
    <ul class="ft-dropdown-menu">
        @for (incentive of menuIncentives(); track incentive) {
            <li (click)="setIncentive(incentive)">
                <a [innerHTML]="incentive | incentiveName"></a>
            </li>
        }
    </ul>
</div>
